<!--
  课程管理 - 新增/编辑
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">

    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont" style="padding-left: 0px;">
          搜索
        </h3>
      </div>
      <div class="card-body ">
        <el-row :gutter="20">
          <el-col :lg="6" :sm="12" class="mb-3">
            <div class="selTitleBox">
              <span class="spTitle">学期</span>
            </div>
            <div class="selBodyBox">
              <el-select v-model="semesterId" placeholder="请选择学期" @change="onChangeSemester" class="width_100Pie">
                <el-option v-for="item in optSemester" :key="item.semesterId" :label="item.name"
                  :value="item.semesterId">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :lg="6" :sm="12" class="mb-3">
            <div class="selTitleBox">
              <span class="spTitle">周</span>
            </div>
            <div class="selBodyBox">
              <el-select v-model="weekId" placeholder="请选择周" class="width_100Pie">
                <el-option v-for="item in optWeek" :key="item.weekIndex" :label="'第 '+item.weekIndex+' 周'"
                  :value="item.weekIndex">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card-footer text-center">
        <el-button type="primary" class="mr-2" slot="append" icon="el-icon-search" @click.native="onSearch()">查询
        </el-button>
        <el-button slot="append" class="mr-2" icon="el-icon-refresh" @click.native="onResetSearch()">重置</el-button>
      </div>
    </el-card>

    <el-card class="box-card">
      <el-alert :title="'操作说明：'+onGetNoDataTip()+'，在右侧课程表中，点击课程可对课程进行相应的调整操作。'" type="warning" :closable="false">
      </el-alert>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="card-header tabsHeader">
        <el-tabs v-model="tabsIndex" type="card" @tab-click="onTabClick">
          <el-tab-pane label="班级课表" name="0"></el-tab-pane>
          <el-tab-pane label="教师课表" name="1"></el-tab-pane>
          <el-tab-pane label="场地课表" name="2"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="card-body">
        <el-row :gutter="20">
          <el-col :span="5">
            <div class="divTreeCont">
              <el-input placeholder="输入关键字进行过滤" v-model="filterText">
                <el-button slot="append" icon="el-icon-refresh-right" @click="onFilterText()"></el-button>
              </el-input>
              <div class="divTreeBox" :style="'height:'+windowHeight+'px'">
                <el-tree :data="treeData" :props="defaultProps" ref="tree" style="margin-top:10px;" node-key="id"
                  @node-click="handleNodeClick" :accordion="true" :default-expand-all="false"
                  :render-content="renderContent" :filter-node-method="filterNode" :highlight-current="true">
                </el-tree>
              </div>
            </div>
          </el-col>
          <el-col :span="19">
            <div v-if="!regNullArray(itemData)">
              <table class="table table-bordered tbClassSchedule">
                <tr>
                  <td width="10%">
                    <div class="divTableTitleBox">
                      <div class="divWeek">星期</div>
                      <div class="divIndex">节次</div>
                    </div>
                  </td>
                  <td class="divWeekName" :width="90/optWeekTitle.length+'%'" v-for="(item,index) in optWeekTitle"
                    :key="index">
                    {{optWeekName[item.dayOfWeek]}}
                  </td>
                </tr>
                <tr v-for="(item,index) in itemData" :key="index">
                  <td class="divTimesBox">{{item.sectionIndex}}</td>
                  <td v-for="(list,indexTwo) in item.children" :key="indexTwo" class="tdSetBox">

                    <div class="noCourse" v-if="regNullArray(list.fix)" @click="onAdjust(list,false)">
                      <!-- 无课程点击设置新课程 -->
                    </div>

                    <draggable v-model="list.fix" :group="onGetGroup(list)" chosenClass="chosen" filter=".forbid"
                      animation="100" :move="onMove">
                      <transition-group class="groupBox">


                        <div v-for="(it,indexThi) in list.fix" :key="indexThi+'0'" class="itemBox"
                          @click="onAdjust(it,true)">
                          <div class="itemTitle">{{it.subject}}</div>
                          <div class="itemInfo" v-if="!regNull(it.teacher) && tabsIndex!='1'">
                            <span class="spTitle">教师</span>
                            <span class="spFonts">{{it.teacher}}</span>
                          </div>
                          <div class="itemInfo" v-if="!regNull(it.classroom) && tabsIndex!='2'">
                            <span class="spTitle">场地</span>
                            <span class="spFonts">{{it.classroom}}</span>
                          </div>
                          <div class="itemInfo" v-if="!regNull(it.class) && tabsIndex!='0'">
                            <span class="spFonts">{{it.class}}</span>
                          </div>
                        </div>



                      </transition-group>
                    </draggable>

                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <el-empty :image-size="200" :description="onGetNoDataTip()"></el-empty>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
      <el-dialog :title="dialogVisibleName" :visible.sync="dialogVisible" :width="isNewCourse?'40%':'60%'"
        :before-close="handleClose" :close-on-press-escape="false" :close-on-click-modal="false">

        <!-- 调课 -->
        <div class="pl-4 pr-4 updateForm">
          <el-row :gutter="30">
            <el-col :md="12" :sm="24" v-if="!isNewCourse">
              <el-row>
                <el-col :span="24">
                  <div class="divOldTitle VerticalMid">
                    原课程信息
                  </div>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="日期">
                    <div class="labelTopBox">
                      <div class="formShowFont">{{ruleForm.oldDate | dateformatDay}}</div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="节次">
                    <div class="labelTopBox">
                      <div class="formShowFont">第 {{ruleForm.oldSectionIndex}} 节</div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="课程">
                    <div class="labelTopBox">
                      <div class="formShowFont">{{ruleForm.oldSubject}}</div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="教师">
                    <div class="labelTopBox">
                      <div class="formShowFont">{{ruleForm.oldTeacher}}</div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="场地">
                    <div class="labelTopBox">
                      <div class="formShowFont">{{regNull(ruleForm.oldRoomId)?'教室':ruleForm.oldClassroom}}</div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :md="isNewCourse?24:12" :sm="24">
              <el-row>
                <el-col :span="24">
                  <div class="divNewTitle VerticalMid">
                    {{isNewCourse?'设置新课程信息':'调整课程信息'}}
                  </div>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="日期">
                    <div class="labelTopBox">
                      <el-date-picker v-model="ruleForm.presentDate" type="date" placeholder="请选择调课日期"
                        class="width_100Pie" @change="onChangeDate" :disabled="isNewCourse">
                      </el-date-picker>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="节次" :prop="isNewCourse?'presentSectionId':null">
                    <div class="labelTopBox">
                      <el-select v-model="ruleForm.presentSectionId" :clearable="ruleForm.isClearable"
                        :disabled="isNewCourse" placeholder="请选择节次" class="width_100Pie" @change="onChangeSection">
                        <el-option v-for="item in optSection" :key="item.sectionId" :label="'第 '+item.sectionIndex+' 节'"
                          :value="item.sectionId">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="课程" :prop="isNewCourse?'presentCourseId':null">
                    <div class="labelTopBox">
                      <el-select v-model="ruleForm.presentCourseId" :clearable="ruleForm.isClearable"
                        placeholder="请选择课程" class="width_100Pie">
                        <el-option v-for="item in optCourse" :key="item.courseId" :label="item.name"
                          :value="item.courseId">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="教师" :prop="isNewCourse?'presentTeacherId':null">
                    <div class="labelTopBox">
                      <el-select v-model="ruleForm.presentTeacherId" :clearable="ruleForm.isClearable"
                        placeholder="请选择教师" class="width_100Pie">
                        <el-option v-for="item in optTeacher" :key="item.userId" :label="item.name"
                          :value="item.userId">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="场地" :prop="isNewCourse?'presentRoomId':null">
                    <div class="labelTopBox">
                      <el-select v-model="ruleForm.presentRoomId" :clearable="ruleForm.isClearable" placeholder="请选择教师"
                        class="width_100Pie">
                        <el-option v-for="item in optRoom" :key="item.roomId" :label="item.name" :value="item.roomId">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item label="调整原因描述" prop="reason">
                <div class="labelTopBox">
                  <el-input type="textarea" :rows="5" placeholder="请输入内容调换课的原因" v-model="ruleForm.reason">
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-row>
            <el-col :span="12" class="text-left">
              <el-button type="danger" @click="onCancelCourse()" v-if="!isNewCourse">取消当前课程</el-button>
              <div v-else class="noBtnBox"></div>
            </el-col>
            <el-col :span="12">
              <el-button @click="handleClose">取 消</el-button>
              <el-button type="primary" @click="onBtnSubmit">确 定</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </el-form>

  </div>
</template>

<script>
  import '@/assets/css/Admin.css';
  import draggable from 'vuedraggable';
  export default {
    components: {
      draggable
    },
    data() {
      return {
        // 加载动画
        fullscreenLoading: false,
        // 学期
        optSemester: [],
        semesterId: null,

        itemData: [],

        // tabs 切换
        tabsIndex: '0',


        filterText: '',
        // 左侧列表
        treeData: [],
        // 树型
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        nowItemID: '',
        nowItemName: '',
        nowDate: null,
        allClassData: [],

        // 周
        optWeek: [],
        weekId: null,

        // 设置调课
        dialogVisible: false,
        dialogVisibleName: '设置课表',
        ruleForm: {
          reason: null,
          originalScheduleId: null, // 原课时ID
          presentScheduleId: null, // 现课时ID
          changeType: null, // 7:退课  2:调课 1：交换课程
          presentDate: null,
          presentSectionId: null,
          presentTeacherId: null,
          presentRoomId: null,
          presentCourseId: null,
          selfStudy: null,


          oldDate: null,
          oldTeacherId: null,
          oldTeacher: null,
          oldSubject: null, // 原计划
          oldSectionIndex: null,
          oldSectionId: null,
          oldClassroom: null,
          oldRoomId: null,
          oldCourseId: null,

          isClearable: true,

          selSectionIndex: null,
          selDayOfWeek: null,
        },
        ruleFormReset: null,

        optSection: [], // 节次
        optRoom: [], // 场地
        optTeacher: [], // 教师
        optCourse: [], // 课程
        optDateInfo: [], // 加载已有的课程

        // 显示星期
        optWeekName: ['', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
        optWeekTitle: [],

        rules: {
          presentSectionId: [{
            required: true,
            message: '请选择节次',
            trigger: 'change'
          }],
          presentCourseId: [{
            required: true,
            message: '请选择课程',
            trigger: 'change'
          }],
          presentTeacherId: [{
            required: true,
            message: '请选择教师',
            trigger: 'change'
          }],
          presentRoomId: [{
            required: true,
            message: '请选择场地',
            trigger: 'change'
          }],

          oldWeekId: [{
            required: true,
            message: '请选择校历周',
            trigger: 'change'
          }],
          oldDayId: [{
            required: true,
            message: '请选择星期',
            trigger: 'change'
          }],
          reason: [{
              required: true,
              message: '描述原因不能为空',
              trigger: 'change'
            },
            {
              max: 256,
              message: '描述原因不能超过256个字符',
              trigger: 'change'
            }
          ],
        },
        windowHeight: document.documentElement.clientHeight,
        allDayData: [],
        isNewCourse: false,
      };
    },
    created() {
      let that = this;
      onGetData(that);
    },
    mounted() {
      let that = this;
      that.windowHeight -= 300;
      if (that.windowHeight < 400) {
        that.windowHeight = 600;
      }
    },
    watch: {
      /**
       * @description 动态搜索
       * @param {Object} val
       */
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      /**
       * @param {Object} objItem
       */
      onGetGroup(objItem) {
        let tpParams = {
          name: 'itxst', //组名为itxst
          pull: true,
          put: true
        }
        return tpParams;
      },
      /**
       * @description move回调方法
       * @param {Object} e
       * @param {Object} originalEvent
       */
      onMove(e, originalEvent) {
        let that = this;
        // if (e.relatedContext.element.sectionsPerWeek == 0) return false;
        // if (e.relatedContext.list.length >= 2) return false;
        return true;
      },
      /**
       * @description 调整节次选择事件
       * @param {Object} objItem
       */
      onChangeSection(objItem) {
        let that = this;
        if (!regNull(objItem)) {

          if (!regNull(that.ruleForm.presentDate)) {


            let apiUrl =
              `/api/admin/course/schedulebydate?semesterId=${that.semesterId}&classId=${that.nowItemID}&date=${timeTransform(that.ruleForm.presentDate,'YYYY-MM-DD')}`;
            ajaxGet(that, apiUrl, null, function(resData) {
              if (!regNullArray(resData)) {

                let temp = resData.filter(item => item.sectionId == objItem);
                if (!regNullArray(temp)) {


                  that.optRoom = [{
                    roomId: '0000-0000',
                    name: '教室',
                    building: null,
                  }];
                  // 课程
                  that.optCourse = [{
                    courseId: '0000-0000',
                    name: '自修课',
                  }];
                  that.optTeacher = [];
                  temp.forEach((item) => {
                    // 课程
                    that.optCourse.push({
                      scheduleId: item.scheduleId,
                      courseId: item.courseId,
                      name: item.subject,
                    });
                    //场地
                    if (!regNull(item.roomId)) {
                      that.optRoom.push({
                        roomId: item.roomId,
                        name: item.classroom
                      });
                    }
                    // 教师
                    that.optTeacher.push({
                      userId: item.teacherId,
                      name: item.teacher
                    });
                  });


                  that.ruleForm.isClearable = false;
                  that.ruleForm.presentCourseId = that.optCourse.length > 1 ? that.optCourse[1].courseId : that
                    .optCourse[0].name;
                  that.ruleForm.presentTeacherId = regNullArray(that.optTeacher) ? null : that.optTeacher[0].userId;
                  that.ruleForm.presentRoomId = that.optRoom.length > 1 ? that.optRoom[1].roomId : that.optRoom[0]
                    .roomId;


                } else {
                  that.ruleForm.isClearable = true;
                  that.ruleForm.presentCourseId = null;
                  that.ruleForm.presentTeacherId = null;
                  that.ruleForm.presentRoomId = null;
                  that.optDateInfo = [];
                  that.onGetAdjustData(that);
                }
              } else {
                that.ruleForm.isClearable = true;
                that.ruleForm.presentCourseId = null;
                that.ruleForm.presentTeacherId = null;
                that.ruleForm.presentRoomId = null;
                that.optDateInfo = [];
                that.onGetAdjustData(that);
              }
            });
          }
        }
      },
      /**
       * @description 调整课程时间选择事件
       */
      onChangeDate(objItem) {
        let that = this;
        that.nowDate = objItem;
        that.ruleForm.presentSectionId = null;
        that.ruleForm.presentCourseId = null;
        that.ruleForm.presentTeacherId = null;
        that.ruleForm.presentRoomId = null;
        that.optDateInfo = [];
        that.onGetAdjustData(that);
      },
      /**
       * @description 点击课程触发事件
       * @param {Object} objItem
       */
      onAdjust(objItem, objType) {
        let that = this;
        let tempItem = that.allClassData.find(item => item.classId == that.nowItemID);
        that.dialogVisibleName = regNull(tempItem) ? '设置换课' : '调整课程表【' + tempItem.name + '】';
        that.dialogVisible = true;

        if (objType) {
          if (!regNull(objItem)) {
            that.isNewCourse = false;
            // 原课程信息
            that.ruleForm.originalScheduleId = objItem.scheduleId; //原课时
            that.ruleForm.oldDate = objItem.date; // 原上课时间
            that.ruleForm.oldSectionId = objItem.sectionId; // 原节次ID
            that.ruleForm.oldSectionIndex = objItem.sectionIndex; // 原节次
            that.ruleForm.oldClassroom = objItem.classroom; // 原场地
            that.ruleForm.oldRoomId = objItem.roomId; // 原场地ID
            that.ruleForm.oldTeacher = objItem.teacher; // 原教师
            that.ruleForm.oldTeacherId = objItem.teacherId; // 原教师ID

            that.ruleForm.oldSubject = objItem.subject; //  原计划
            that.ruleForm.oldCourseId = objItem.courseId; // 原课程ID

            that.optDateInfo = [];
            that.onGetAdjustData(that);
          }
        } else {
          if (!regNull(objItem)) {
            that.isNewCourse = true;
            that.ruleForm.isClearable = false;
            that.ruleForm.selSectionIndex = objItem.sectionIndex;
            that.ruleForm.selDayOfWeek = objItem.dayOfWeek;
            that.optDateInfo = [];
            that.onGetAdjustData(that);
          }
        }
      },
      /**
       * @description 获取
       * @param {Object} that
       */
      onGetAdjustData(that) {
        // 场地
        that.optRoom = [{
          roomId: '0000-0000',
          name: '教室',
          building: null,
        }];
        if(that.isNewCourse){
          // 课程
          that.optCourse = [];

        }else{
          that.optCourse = [{
            courseId: '0000-0000',
            name: '自修课',
          }];
        }
        // 节次
        ajaxGet(that, '/api/admin/semestercell/section/' + that.semesterId, null, function(resSection) {
          // 场次
          ajaxGet(that, '/api/admin/baseclassroom/enable', null, function(resRoom) {
            // 教师
            ajaxGet(that, '/api/admin/sysuser/enable', null, function(resUser) {
              // 课程
              ajaxGet(that, '/api/admin/course/coursebyclass?semesterId=' + that.semesterId + '&classId=' +
                that.nowItemID, null,
                function(resCourse) {
                  that.optTeacher = resUser; // 教师
                  that.optSection = resSection; // 节次
                  that.optCourse.push(...resCourse); // 课程
                  that.optRoom.push(...resRoom); // 场地

                  // 原无课程，设置默认选项
                  if (that.isNewCourse) {
                    if (!regNullArray(resSection)) {
                      let tpSection = resSection.find(item => item.sectionIndex == that.ruleForm
                        .selSectionIndex);
                      if (!regNull(tpSection)) {
                        that.ruleForm.presentSectionId = tpSection.sectionId;
                      }
                    }

                    // 周
                    if (!regNullArray(that.optWeek)) {
                      let tpWeek = that.allDayData.find(item => item.dayOfWeek == that.ruleForm
                        .selDayOfWeek && item.weekIndex == that.weekId);
                      console.log('selDayOfWeek===>', that.ruleForm.selDayOfWeek);
                      console.log('weekId===>', that.weekId);
                      if (!regNull(tpWeek)) {
                        that.ruleForm.presentDate = timeTransform(tpWeek.day, 'YYYY-MM-DD');
                      }
                    }

                    //   that.ruleForm.presentRoomId='0000-0000';
                  }
                });
            });
          });
        });

      },
      /**
       * @description 提交
       */
      onBtnSubmit() {
        let that = this;
        that.$refs["ruleForm"].validate(valid => {
          if (valid) {
            // switch (that.ruleForm.changeType) {
            //   case 7:
            //     that.onCancelCourse();
            //     break;
            //   case 1:
            //     // that.onExchangeCourse(that);
            //     break;
            //   case 2:
            //     // that.onTuneCourse(that);
            //     break;
            // }

            let tpParams = {};
            // 原课时
            tpParams.originalScheduleId = that.ruleForm.originalScheduleId;

            // 时间
            if (regNull(that.ruleForm.presentDate)) {
              tpParams.presentDate = timeTransform(that.ruleForm.oldDate, 'YYYY-MM-DD');
            } else {
              tpParams.presentDate = timeTransform(that.ruleForm.presentDate, 'YYYY-MM-DD');
            }

            // 节次
            if (regNull(that.ruleForm.presentSectionId)) {
              tpParams.presentSectionId = that.ruleForm.oldSectionId;
            } else {
              tpParams.presentSectionId = that.ruleForm.presentSectionId;
            }

            // 课程
            tpParams.changeType = 2;
            if (regNull(that.ruleForm.presentCourseId)) {
              tpParams.presentCourseId = that.ruleForm.oldCourseId;
            } else {
              if (that.ruleForm.presentCourseId == '0000-0000') {
                tpParams.presentCourseId = null;
                tpParams.selfStudy = true; // 自修课
              } else {
                tpParams.presentCourseId = that.ruleForm.presentCourseId;
                tpParams.selfStudy = false;
                let tpCourse = that.optCourse.find(item => item.courseId == that.ruleForm.presentCourseId);
                if (!regNull(tpCourse)) {
                  // 判断是否为换课
                  if (!regNull(tpCourse.scheduleId)) {
                    tpParams.changeType = 1;
                    tpParams.presentScheduleId = tpCourse.scheduleId;
                  }
                }
              }
            }

            //教师
            if (regNull(that.ruleForm.presentTeacherId)) {
              tpParams.presentTeacherId = that.ruleForm.oldTeacherId;
            } else {
              tpParams.presentTeacherId = that.ruleForm.presentTeacherId;
            }


            // 场地
            if (regNull(that.ruleForm.presentRoomId)) {
              tpParams.presentRoomId = that.ruleForm.oldRoomId;
            } else {
              if (that.ruleForm.presentRoomId == '0000-0000') {
                tpParams.presentRoomId = null;
              } else {
                tpParams.presentRoomId = that.ruleForm.presentRoomId;
              }
            }
            let paramData = null;

            if (that.isNewCourse) {
              tpParams.changeType = 8;
              paramData = {
                reason: that.ruleForm.reason,
                logs: [tpParams]
              }
            } else {
              paramData = {
                reason: that.ruleForm.reason,
                logs: [tpParams]
              }
            }

            ajaxPut(that, '/api/admin/course/changecourse', paramData, function(res) {
              that.fullscreenLoading = false;
              let tpParams = {
                id: that.nowItemID
              }
              that.handleNodeClick(tpParams);
              that.handleClose();
            });


          } else {
            setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
            }, 1)
            return false;
          }
        });
      },
      /**
       * @description 提交取消课程
       */
      onCancelCourse() {
        let that = this;

        that.$refs["ruleForm"].validate(valid => {
          if (valid) {

            confirmDelete(that, '确认取消当前课程吗？', function(res) {
              if (res == true) {
                that.fullscreenLoading = true;
                let tpParams = {
                  reason: that.ruleForm.reason,
                  logs: [{
                    originalScheduleId: that.ruleForm.originalScheduleId,
                    changeType: 7
                  }]
                }
                ajaxPut(that, '/api/admin/course/changecourse', tpParams, function(res) {
                  that.fullscreenLoading = false;
                  let tpParams = {
                    id: that.nowItemID
                  }
                  that.handleNodeClick(tpParams);
                  that.handleClose();
                });
              }
            })



          } else {
            setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
            }, 1)
            return false;
          }
        });


      },
      /**
       * @description 换课
       * @param {Object} that
       */
      onExchangeCourse(that) {
        that.fullscreenLoading = true;
        let tpParams = {
          reason: that.ruleForm.reason,
          logs: [{
            originalScheduleId: that.ruleForm.originalScheduleId,
            changeType: 1,
            presentScheduleId: that.ruleForm.presentScheduleId
          }]
        }
        ajaxPut(that, '/api/admin/course/changecourse', tpParams, function(res) {
          that.fullscreenLoading = false;
          let tpParams = {
            id: that.nowItemID
          }
          that.handleNodeClick(tpParams);
          that.handleClose();
        });
      },
      /**
       * @description 调课
       * @param {Object} that
       */
      onTuneCourse(that) {
        that.fullscreenLoading = true;
        // 场地
        let tpRoom = that.ruleForm.presentRoomId;
        if (tpRoom == '0000-0000') {
          tpRoom = null;
        } else if (regNull(tpRoom)) {
          tpRoom = that.ruleForm.oldRoomId;
        }

        // 课程
        let tpCourse = that.ruleForm.presentCourseId;
        if (tpCourse == '0000-0000') {
          that.ruleForm.selfStudy = true;
          tpCourse = null;
        } else if (regNull(tpCourse)) {
          tpCourse = that.ruleForm.oldCourseId;
          that.ruleForm.selfStudy = false;
        }



        let tpParams = {
          reason: that.ruleForm.reason,
          logs: [{
            originalScheduleId: that.ruleForm.originalScheduleId,
            changeType: 2,
            presentDate: regNull(that.ruleForm.presentDate) ? that.ruleForm.oldDate : timeTransform(that.ruleForm
              .presentDate), // 时间
            presentSectionId: regNull(that.ruleForm.presentSectionId) ? that.ruleForm.oldSectionId : that.ruleForm
              .presentSectionId, //节次
            presentTeacherId: regNull(that.ruleForm.presentTeacherId) ? that.ruleForm.oldTeacherId : that.ruleForm
              .presentTeacherId, //教师
            presentRoomId: tpRoom, //场地
            presentCourseId: tpCourse, //课程
            selfStudy: that.ruleForm.selfStudy, // 是否自修
          }]
        }
        ajaxPut(that, '/api/admin/course/changecourse', tpParams, function(res) {
          that.fullscreenLoading = false;
          let tpParams = {
            id: that.nowItemID
          }
          that.handleNodeClick(tpParams);
          that.handleClose();
        });
      },



      /**
       * @description 点击设置调课操作
       */
      onSetCourse(objType) {
        let that = this;
        if (!regNull(that.nowItemID)) {
          let tempItem = that.allClassData.find(item => item.classId == that.nowItemID);
          that.ruleForm.changeType = objType;
          switch (objType) {
            case 1: // 换课
              that.dialogVisibleName = regNull(tempItem) ? '设置换课' : '设置换课【' + tempItem.name + '】';
              break;
            case 2: // 调课
              that.dialogVisibleName = regNull(tempItem) ? '设置调课' : '设置调课【' + tempItem.name + '】';
              that.onGetTuneData(that);
              break;
            case 7: // 取消课程
              that.dialogVisibleName = regNull(tempItem) ? '取消课程' : '取消课程【' + tempItem.name + '】';
              break;
          }
          that.dialogVisible = true;
        } else {
          warning(that, '请选择班级');
        }
      },

      /**
       * @description 关闭对话框
       */
      handleClose() {
        let that = this;
        that.nowDate = null;
        that.ruleForm = JSON.parse(JSON.stringify(that.ruleFormReset));
        that.dialogVisible = false;
        try {
          that.$refs["ruleForm"].resetFields();
        } catch {}
      },
      /**
       * @description 重置
       */
      onResetSearch() {
        let that = this;
        that.weekId = null;
        onGetData(that);
      },
      /**
       * @description 搜索
       */
      onSearch() {
        let that = this;
        let tpParams = {
          id: that.nowItemID
        }
        that.handleNodeClick(tpParams);
      },
      /**
       * @description 无数据提示文字
       */
      onGetNoDataTip() {
        let that = this;
        switch (that.tabsIndex) {
          case '0':
            return '请点击左侧班级';
          case '1':
            return '请点击左侧教师';
          case '2':
            return '请点击左侧场地';
        }
      },
      /**
       * @description 头部Tabs切换事件
       * @param {Object} objTab
       * @param {Object} objEvent
       */
      onTabClick() {
        let that = this;
        that.nowItemID = null;
        that.nowItemName = null;
        that.onFilterText();
        switch (that.tabsIndex) {
          case '0':
            // 加载班级
            that.onGetClass(that);
            break;
          case '1':
            // 加载教师
            that.onGetTeacher(that);
            break;
          case '2':
            // 加载场地
            that.onGetRoom(that);
            break;
        }
      },
      /**
       * @description 树型点击事件
       * @param {Object} objItem
       */
      handleNodeClick(objItem) {
        let that = this;
        if (!regNull(objItem.id)) {
          let apiUrl = null;
          that.nowItemID = objItem.id;
          that.nowItemName = objItem.name;

          // 按周获取课表
          switch (that.tabsIndex) {
            case '0':
              apiUrl =
                `/api/admin/course/schedule?semesterId=${that.semesterId}&classId=${objItem.id}&week=${that.weekId}`;
              break;
            case '1':
              apiUrl =
                `/api/admin/course/userschedule?semesterId=${that.semesterId}&teacherId=${objItem.id}&week=${that.weekId}`;
              break;
            case '2':
              apiUrl =
                `/api/admin/course/roomschedule?semesterId=${that.semesterId}&roomId=${objItem.id}&week=${that.weekId}`;
              break;
          }

          ajaxGet(that, apiUrl, null, function(resData) {
            onGetDataOther(that, resData);
          });
        } else {
          that.itemData = [];
        }
      },
      /**
       * @description 重置搜索内容
       */
      onFilterText() {
        this.filterText = "";
      },
      /**
       * @description 获取班级
       * @param {Object} that
       */
      onGetClass(that) {
        that.fullscreenLoading = true;
        that.itemData = [];
        that.treeData = [];
        ajaxGet(that, '/api/admin/course/classbysemester?semesterId=' + that.semesterId, null, function(
          resClass) {
          that.fullscreenLoading = false;
          that.optSchool = [{
            collegeId: null,
            college: '全校'
          }];

          if (!regNullArray(resClass)) {
            that.allClassData = resClass;
            that.treeData = [{
              id: null,
              value: null,
              name: "班级信息",
              title: "班级信息",
              children: [],
            }];
            that.optClass = [];


            const res = new Map();
            let temp = resClass.filter((arr) => !res.has(arr.collegeId) && res.set(arr.collegeId, 1));
            that.optSchool.push(...temp);

            temp.forEach((item) => {
              let tpClass = [];
              let tpClassTwo = [];
              resClass.forEach((list) => {
                if (list.collegeId == item.collegeId) {
                  tpClass.push({
                    id: list.classId,
                    value: list.classId,
                    name: list.name,
                    title: list.name,
                  });
                  tpClassTwo.push({
                    value: list.classId,
                    label: list.name,
                  });
                }
              });
              // 左侧选择
              that.treeData[0].children.push({
                id: item.collegeId,
                value: null,
                name: item.college,
                title: item.college,
                children: tpClass,
              });
              // 导出需要选择的数据
              that.optClass.push({
                value: item.collegeId,
                label: item.college,
                children: tpClassTwo
              });
            });
          }
        });
      },
      /**
       * @description 获取教师
       * @param {Object} that
       */
      onGetTeacher(that) {
        that.fullscreenLoading = true;
        that.itemData = [];
        ajaxGet(that, '/api/admin/course/teacherbysemester?semesterId=' + that.semesterId, null, function(
          resTeacher) {
          that.fullscreenLoading = false;
          if (!regNullArray(resTeacher)) {
            that.optTeacher = resTeacher;

            that.treeData = [{
              id: null,
              value: null,
              name: "授课教师",
              title: "授课教师",
              children: [],
            }];
            resTeacher.forEach((item) => {
              that.treeData[0].children.push({
                id: item.userId,
                value: item.userId,
                name: item.name,
                title: item.name,
              });
            });
          }
        });
      },
      /**
       * @description 获取场地
       * @param {Object} that
       */
      onGetRoom(that) {
        that.fullscreenLoading = true;
        that.itemData = [];
        that.treeData = [];
        ajaxGet(that, '/api/admin/course/roombysemester?semesterId=' + that.semesterId, null, function(
          resRoom) {
          that.fullscreenLoading = false;
          if (!regNullArray(resRoom)) {
            that.treeData = [{
              id: null,
              value: null,
              name: "场地信息",
              title: "场地信息",
              children: [],
            }];
            const res = new Map();
            let temp = resRoom.filter((arr) => !res.has(arr.buildingId) && res.set(arr.buildingId, 1));
            temp.forEach((item) => {
              let tpData = [];
              resRoom.forEach((list) => {
                if (list.buildingId == item.buildingId) {
                  tpData.push({
                    id: list.roomId,
                    value: list.roomId,
                    name: list.name,
                    title: list.name,
                  });
                }
              });
              that.treeData[0].children.push({
                id: item.buildingId,
                value: null,
                name: item.building,
                title: item.building,
                children: tpData,
              });
            });
          }
        });

      },

      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      /**
       * @description 选择学期事件
       * @param {Object} objItem
       */
      onChangeSemester(objItem) {
        let that = this;
        that.onGetClass(that);
      },
      /**
       * @description 去除重复值
       * @param {Object} arr
       */
      onArrUnique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.sectionIndex) && res.set(arr.sectionIndex, 1));
      },
      renderContent(h, {
        node,
        data,
        store
      }) {
        return ( < span class = "custom-tree-node" >
          <
          span style = "font-size:14px;" > {
            node.label
          } < /span></span > );
      },
    },
  };

  /**
   * @description 获取数据
   * @param {Object} that
   */
  function onGetData(that) {
    that.fullscreenLoading = true;
    ajaxGet(that, '/api/admin/semester', null, function(resSemester) {
      that.fullscreenLoading = false;
      that.optSemester = resSemester;
      let temp = resSemester.find((item) =>
        item.isCurrent == true);
      if (!regNull(temp)) {
        that.semesterId = temp.semesterId;
      } else {
        that.semesterId = resSemester[0].semesterId;
      }

      // 按学期获取校历
      ajaxGet(that, '/api/admin/semesterday/search', {
        SemesterId: that.semesterId
      }, function(resWeek) {
        that.fullscreenLoading = false;
        that.optWeek = [];

        that.allDayData = resWeek;

        const res = new Map();
        that.optWeek = resWeek.filter((arr) => !res.has(arr.weekIndex) && res.set(arr.weekIndex, 1));
        let tempWeek = resWeek.find(item => timeTransform(item.day, 'YYYY-MM-DD') == timeTransform(new Date(),
          'YYYY-MM-DD'));
        if (!regNull(tempWeek)) {
          that.weekId = tempWeek.weekIndex;
        } else {
          that.weekId = 1;
        }

        that.ruleFormReset = JSON.parse(JSON.stringify(that.ruleForm));
      });



      that.onTabClick();
    });

  }

  function onGetDataOther(that, objData) {

    if (!regNull(that.semesterId)) {
      ajaxGet(that, '/api/admin/semestercell/' + that.semesterId, null, function(resData) {
        that.itemData = [];

        let optlist = [];

        for (var it of resData) {
          it.fix = [];
          for (var it2 of objData) {
            if (it.dayOfWeek == it2.dayOfWeek && it.sectionIndex == it2.sectionIndex) {
              it.fix.push({
                timetableId: it2.timetableId,
                planId: it2.planId,
                subject: it2.subject,
                classroom: it2.classroom,
                teacher: it2.teacher,
                class: it2.class,
                scheduleId: it2.scheduleId, // 原课时ID,
                date: it2.date, // 上课时间
                sectionId: it2.sectionId, // 节次ID
                sectionIndex: it2.sectionIndex, // 节次
                teacherId: it2.teacherId, // 上课老师ID
                roomId: it2.roomId, // 场地ID
                classroom: it2.classroom,
                courseId: it2.courseId,
              })
            }
          }
        }
        that.fullscreenLoading = false;
        if (!regNullArray(objData)) {
          // 获取星期
          const res = new Map();
          let weekTitle = resData.filter((arr) => !res.has(arr.dayOfWeek) && res.set(arr.dayOfWeek, 1));
          that.optWeekTitle = weekTitle.sort((a, b) => a.dayOfWeek - b.dayOfWeek);

          // optWeekTitle
          let temp = that.onArrUnique(resData);
          temp = temp.sort((a, b) => a.sectionIndex - b.sectionIndex);
          temp.forEach((item) => {
            let tpData = resData.filter((list) => {
              if (list.sectionIndex == item.sectionIndex) {
                list.dayOfWeek = setInt(list.dayOfWeek);
                return list;
              }
            });
            tpData = tpData.sort((a, b) => a.dayOfWeek - b.dayOfWeek);
            that.itemData.push({
              sectionIndex: item.sectionIndex,
              children: tpData
            });
          });
        }
      });
    }
  }
</script>

<style scoped="scoped" lang="less">
  .noBtnBox {
    width: 300px;
    height: 30px;
  }

  .divOldTitle {
    height: 40px;
    color: #909399;
    background: #f4f4f5;
    border-color: #d3d4d6;
    border-radius: 5px;
    font-size: 16px;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }

  .divNewTitle {
    height: 40px;
    color: #409eff;
    background: #ecf5ff;
    border-color: #b3d8ff;
    border-radius: 5px;
    font-size: 16px;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }


  .labelTopBox {
    margin-top: -20px;

    .formShowFont {
      padding: 0 15px;
      background-color: #FFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #FFF;
      box-sizing: border-box;
      color: #606266;
      height: 40px;
      line-height: 40px;
    }
  }

  .selTitleBox {
    font-size: 14px;

    .spTitle {
      color: #303133;
    }
  }

  .selBodyBox {
    padding-top: 5px;
  }


  .itemBox {
    margin-bottom: 10px;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    .itemTitle {
      text-align: center;
      border: 1px solid #409eff;
      background-color: #409eff;
      color: #FFFFFF;
      padding-top: 5px;
      padding-bottom: 5px;
      font-size: 14px;
    }

    .itemInfo {
      font-size: 12px;
      text-align: center;
      padding-top: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #DCDFE6;
      border-left: 1px solid #DCDFE6;
      border-right: 1px solid #DCDFE6;
      background-color: #FFFFFF;

      .spTitle {
        padding-right: 2px;
        color: #909399;
      }

      .spFonts {
        padding-left: 2px;
        color: #303133;
      }
    }
  }

  .divTreeCont {
    border: 1px solid #DDDDDD;
    padding: 15px;
    border-radius: 4px;

    .divTreeBox {
      overflow: auto;
      min-width: 100px
    }
  }

  .tabsHeader {
    margin: -18px -20px;
    background-color: #f5f7fa;
    position: relative;

    .divSemesterBox {
      position: absolute;
      right: 6px;
      top: 6px;

      .spTitle {
        font-size: 14px;
      }
    }
  }

  .tbClassSchedule {
    .groupBox {
      display: block;
      min-height: 40px;
    }

    .tdSetBox {
      position: relative;

      .noCourse {
        position: absolute;
        cursor: pointer;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        &:hover {
          background-color: #eafde2;
        }
      }
    }


    td {
      border: 2px solid #aaa;
    }

    .divTableTitleBox {
      background-image: linear-gradient(to bottom left, #a0cfff 50%, #aaa, #a0cfff 51%);
      height: 60px;
      position: relative;
      margin: -0.75rem;

      .divWeek {
        position: absolute;
        top: 5px;
        right: 5px;
        color: #000000;
      }

      .divIndex {
        position: absolute;
        bottom: 5px;
        left: 5px;
        color: #000000;
      }
    }

    .divWeekName {
      background-color: #a0cfff;
      text-align: center;
      font-size: 18px;
      padding-top: 5px;
      padding-bottom: 5px;
      vertical-align: middle;
      color: #000000;
    }

    .divTimesBox {
      height: 60px;
      vertical-align: middle;
      background-color: #a0cfff;
      text-align: center;
      color: #000000;
      height: 70px;
    }
  }
</style>


<style lang="less">
  .tabsHeader {
    .el-tabs__header {
      margin: 0;
      margin-bottom: -1px;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__nav {
      border: none;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      background-color: #FFFFFF;
    }
  }

  .updateForm {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
</style>
